import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const ModuleContext = createContext();
const MODULE_KEY = 'gl.activeModule';

// Valid module ids: '' (picker), 'custody', 'gold', 'loans'
export function ModuleProvider({ children }) {
  const [activeModule, setActiveModule] = useState('');

  useEffect(() => {
    const saved = localStorage.getItem(MODULE_KEY);
    if (saved) setActiveModule(saved);
  }, []);

  useEffect(() => {
    localStorage.setItem(MODULE_KEY, activeModule || '');
  }, [activeModule]);

  const value = useMemo(() => ({
    activeModule,
    setActiveModule,
    goToPicker: () => setActiveModule(''),
  }), [activeModule]);

  return <ModuleContext.Provider value={value}>{children}</ModuleContext.Provider>;
}

export function useModule() {
  const ctx = useContext(ModuleContext);
  if (!ctx) throw new Error('useModule must be used within a ModuleProvider');
  return ctx;
}
